import React from 'react';
import Editor from '../../Editor';
import { EditorProps } from '../../types';
import cn from 'classnames';
import { extConfig } from './config';

import viewerStyles from '../../../Viewer/presets/Journal/Journal.scss';
import s from './Journal.scss';

const JournalEditor: React.FC<
  Omit<EditorProps, 'extensionConfig' | 'presetId'>
> = props => {
  return (
    <Editor
      {...props}
      withinModal
      presetId="journal"
      className={cn(s['root'], viewerStyles['root'])}
      extensionConfig={extConfig}
    ></Editor>
  );
};
JournalEditor.displayName = 'JournalEditor';

export default JournalEditor;
